import { useState, useEffect } from "react"
import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    IconButton,
} from "@mui/material"
import { Add, Remove } from "@mui/icons-material"
import { useOrder } from "context/OrderContext"
import { useSelector } from "react-redux"
import CustomButton from "components/Fileds/CustomButton"
import AddOnsContent from "./AddOnsContent"
import { formatCurrency } from "utils/function"

const AddOnsDialog = ({ open, onClose, item }) => {
    const { addItemToOrder } = useOrder()
    const userData = useSelector((state) => state?.posData)
    // track qty and which add-on IDs are selected
    const [quantity, setQuantity] = useState(1)
    const [selectedAddOnIds, setSelectedAddOnIds] = useState([])

    // reset whenever a new item opens
    // useEffect(() => {
    //     if (!open || !item) return

    //     // if item already in cart, grab its qty & its addOn IDs
    //     const existingQty = getItemQuantity(item)
    //     setQuantity(existingQty > 0 ? existingQty : 1)

    //     const existingAddOns = item.addOns || []
    //     setSelectedAddOnIds(existingAddOns.map((ao) => ao.id))

    // }, [open, item, getItemQuantity])

    useEffect(() => {
        if (!open) return

        setQuantity(1)              // always start at 1
        setSelectedAddOnIds([])     // no add-ons checked by default
    }, [open])

    // toggle checkbox or radio
    const handleToggle = (addOnId, isRadio = false, groupAddOnIds = []) => {
        if (isRadio) {
            // setSelectedAddOnIds([addOnId])
            setSelectedAddOnIds((prev) => {
                // remove any ids that belong to this radio-group
                const withoutGroup = prev.filter((id) => !groupAddOnIds.includes(id))
                // add the selected radio id
                return [...withoutGroup, addOnId]
            })
        } else {
            setSelectedAddOnIds((prev) =>
                prev.includes(addOnId)
                    ? prev.filter((id) => id !== addOnId)
                    : [...prev, addOnId]
            )
        }
    }

    // compute total: base item.price + sum of selected add-ons, times qty
    const calculateTotalPrice = () => {
        const addOnsTotal = item.groups
            .flatMap((g) => g.add_ons)
            .filter((ao) => selectedAddOnIds.includes(ao.id))
            .reduce((sum, ao) => sum + ao.price, 0)

        return (item.price + addOnsTotal) * quantity
    }

    const handleAddItem = () => {
        // build final addOns array
        const chosen = item.groups
            .flatMap((g) => g.add_ons)
            .filter((ao) => selectedAddOnIds.includes(ao.id))
            .map((ao) => ({ id: ao.id, name: ao.name, price: ao.price, notes: ao.notes }))

        addItemToOrder({
            ...item,
            quantity,
            addOns: chosen,
            totalPrice: calculateTotalPrice(),
        })

        onClose()
    }

    if (!item) return null
    return (
        <Dialog className="add-ons-container" open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '20px', padding: '10px', color: 'black' } }}>
            <DialogContent sx={{
                p: 0, "&::-webkit-scrollbar": {
                    width: 0,
                    height: 0,
                }, msOverflowStyle: "none", scrollbarWidth: "none",
            }}
            >
                <AddOnsContent
                    item={item}
                    onClose={onClose}
                    selectedAddOnIds={selectedAddOnIds}
                    handleToggle={handleToggle}
                >
                    {/* Quantity + Add Button */}
                    <Box className='d-flex align-items-center qunatity-add-container'>
                        <Box className='d-flex align-items-center q-a-r-c'>
                            <IconButton size="small" onClick={() => setQuantity(Math.max(1, quantity - 1))} disabled={quantity <= 1}>
                                <Remove fontSize="small" sx={{ color: 'black' }} />
                            </IconButton>
                            <Typography >{quantity}</Typography>
                            <IconButton size="small" onClick={() => setQuantity(quantity + 1)}>
                                <Add fontSize="small" sx={{ color: 'black' }} />
                            </IconButton>
                        </Box>

                        <CustomButton
                            onClick={handleAddItem}
                            sx={{ borderRadius: '10px', width: '200px', padding: 1.2 }}
                        >
                            ADD ITEM - {formatCurrency(calculateTotalPrice().toFixed(2), userData?.vendor?.currency)}
                        </CustomButton>
                    </Box>
                </AddOnsContent>
            </DialogContent>
        </Dialog>
    )
}

export default AddOnsDialog
